import { render, staticRenderFns } from "./LeaveHistory.vue?vue&type=template&id=2ff961ea&scoped=true&"
import script from "./LeaveHistory.vue?vue&type=script&setup=true&lang=js&"
export * from "./LeaveHistory.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff961ea",
  null
  
)

export default component.exports